import React from "react";

import styles from '../../tractionAI.module.scss';
import ScoutCompanies from "modules/tractionAI/screens/scout/scoutCompanies";

const ScoutItemResponse = ({ item, index }) => {
  return (
    <div className={`d-flex flex-column justify-content-end pr-2 ${index !== 0 ? 'mt-5' : ''}`}>
      <div className="d-flex aling-items-start justify-content-start mb-2">
        <div className={styles.searchByQuery}>
          Recommended Companies {item.isCompanySearch ? 'similar to:' : 'based on the problem:'} <b>{item.searchByQuery}</b>
        </div>
      </div>
      <ScoutCompanies companies={item.data || []} index={index} />
    </div>
  );
};

export default React.memo(ScoutItemResponse);
